import React from "react"
import PropTypes from "prop-types"
import SanityImage from "gatsby-plugin-sanity-image"
import useMediaQuery from "hooks/useMediaQuery"
import theme from "styles/theme"

const layoutBreak = "@media (max-width: 650px)"

const TestimonialCard = ({ quote, attribution, image }) => {
  const mobile = useMediaQuery(layoutBreak)

  return (
    <div
      css={{
        maxWidth: 943,
        margin: "60px auto 40px",
        backgroundColor: theme.white,
        borderBottom: `8px solid ${theme.midBlue}`,
        display: "grid",
        gridTemplateColumns: "178px 1fr",
        [layoutBreak]: {
          maxWidth: 400,
          display: "block",
        },
      }}
    >
      <div css={{ position: "relative" }}>
        <SanityImage
          {...image}
          width={mobile ? 300 : 178}
          height={mobile ? 160 : 242}
          css={{
            display: "block",
            position: "absolute",
            top: 0,
            left: 0,
            bottom: 0,
            width: "100%",
            height: "100%",
            objectFit: "cover",
            [layoutBreak]: {
              width: "100%",
              display: "block",
              objectFit: "initial",
            },
          }}
        />
      </div>

      <div
        css={theme.expandQueries(
          {
            padding: [45, "32px 37px", "30px 20px"],
          },
          ["root", theme.tablet, "@media (max-width: 650px)"]
        )}
      >
        <div
          css={theme.expandQueries({
            fontSize: [17, 15, 14],
            fontStyle: "italic",
            lineHeight: 1.4,
            color: theme.darkGray,
            ":before": { content: "'“'" },
            ":after": { content: "'”'" },
          })}
        >
          {quote}
        </div>

        <div
          css={{
            ...theme.previewText,
            color: theme.gray,
            marginTop: 10,
          }}
        >
          {attribution}
        </div>
      </div>
    </div>
  )
}

TestimonialCard.propTypes = {
  quote: PropTypes.string.isRequired,
  attribution: PropTypes.string.isRequired,
  image: PropTypes.shape({
    hotspot: PropTypes.object,
    crop: PropTypes.object,
    asset: PropTypes.object.isRequired,
  }).isRequired,
}

export default TestimonialCard
